// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { CustomerInfoWithoutInvoicedCityTaxFragment } from '../../fragments/generated/customer-info-without-invoiced-city-tax.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetCityTaxCheckInformationQueryVariables = Types.Exact<{
  cityTaxCheckInformationRequestDTO: Types.GetCityTaxCheckInformationRequestDtoInput;
}>;


export type GetCityTaxCheckInformationQueryResult = { __typename?: 'Query', getCityTaxCheckInformation: { __typename?: 'CityTaxCheckInformationDTO', uncoveredDaysForCityTaxDefinition: Array<LocalDate>, customerInfoWithoutInvoicedCityTax: Array<{ __typename?: 'CustomerInfoWithoutInvoicedCityTaxDTO', checkInDate: LocalDate, checkOutDate: LocalDate, name: string | null, reservationId: number, roomNumber: string, surname: string }> } | null };

export const GetCityTaxCheckInformationGql = gql`
    query GetCityTaxCheckInformation($cityTaxCheckInformationRequestDTO: GetCityTaxCheckInformationRequestDTOInput!) {
  getCityTaxCheckInformation(
    cityTaxCheckInformationRequestDTO: $cityTaxCheckInformationRequestDTO
  ) {
    customerInfoWithoutInvoicedCityTax {
      ...CustomerInfoWithoutInvoicedCityTax
    }
    uncoveredDaysForCityTaxDefinition
  }
}
    ${CustomerInfoWithoutInvoicedCityTaxFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCityTaxCheckInformationInjectable extends Apollo.Query<GetCityTaxCheckInformationQueryResult, GetCityTaxCheckInformationQueryVariables> {
    override document = GetCityTaxCheckInformationGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */